import { StatusChipType } from '@utmost.co/utmost-design-system';
import { FieldPermission } from '../../../forms';

export const getStatusType = (permission?: FieldPermission, policyKey?: string) => {
  if (!permission || !policyKey) return StatusChipType.GREY;

  const legacyKey = mapPolicyKeyToPermissionKey(policyKey);
  const value = permission[legacyKey];

  if (value === true) return StatusChipType.LIGHT_GREEN;
  if (value === false) return StatusChipType.LIGHT_RED;

  return StatusChipType.GREY;
};

export const mapPolicyKeyToPermissionKey = (key: string): keyof FieldPermission => {
  if (key === 'UPDATE') return 'WRITE';
  return key as keyof FieldPermission;
};
